<section
    id="sidebarSecondary"
    appCollapse
    [expandedWidth]="expandedWidth"
    collapsedWidth="22px"
    [initiallyExpanded]="shouldExpand"
    class="secondary-nav secondary-sidebar bg-primary-100 d-flex ps-0 h-100"
    [ngClass]="{
        'd-none': isNotExpandable
    }"
>
    <div class="collapse-icon d-flex justify-content-end align-items-center w-100">
        <button (click)="toggleCollapse()" class="border border-450 rounded-circle bg-lightest-grey position-fixed p-0">
            <i
                [ngClass]="{
                    'fa-chevron-double-left': shouldExpand,
                    'fa-chevron-double-right': !shouldExpand
                }"
                class="far text-normal-grey"
            ></i>
        </button>
    </div>
    <div
        appCollapse
        [initiallyExpanded]="shouldExpand"
        [expandedWidth]="expandedWidth"
        collapsedWidth="22px"
        class="secondary-sidebar-content d-flex flex-row flex-lg-column align-items-start ps-0 pt-0 pb-0 h-100 bg-primary-100 position-fixed border-end"
    >
        <div
            [@addMarginToContent]="shouldExpand ? 'add' : 'subtract'"
            class="secondary-sidebar-content"
            [style.width]="expandedWidth"
            [style.min-width]="expandedWidth"
        >
            <section
                class="institution-name-section d-flex justify-content-center align-items-center w-100 border-bottom ps-3 pe-4 py-3"
            >
                @if (institutionSelectData.length > 1) {
                    <div class="d-flex flex-column justify-content-between h-100">
                        <ng-container
                            *ngTemplateOutlet="
                                institutionName;
                                context: {name: selectedInstitution.text, limit: 37, cssClass: 'mb-0 mt-2'}
                            "
                        ></ng-container>
                        <a
                            href="#"
                            role="button"
                            id="change-institution-link"
                            (click)="$event.preventDefault(); onChangeInstitutionClick()"
                        >
                            Change
                        </a>
                    </div>
                } @else {
                    <ng-container
                        *ngTemplateOutlet="
                            institutionName;
                            context: {name: selectedInstitution.text, limit: 57, cssClass: 'mb-0'}
                        "
                    ></ng-container>
                }
            </section>
            <section class="secondary-filters-section overflow-y-auto mb-5">
                <ng-template #filterHost></ng-template>
            </section>
        </div>
    </div>
</section>

<ng-template #institutionName let-name="name" let-limit="limit" let-cssClass="cssClass">
    @if (name.length > limit) {
        <h3 [class]="cssClass" class="text-break" truelearnWebTooltip [tooltipHtml]="name">
            {{ name | truncate: limit }}
        </h3>
    } @else {
        <h3 [class]="cssClass" class="text-break">
            {{ name }}
        </h3>
    }
</ng-template>
